
/** 视口方向导航器悬停目标的有限类型集合。 */
export const ViewportGizmoHoverTargetKind = {
  /** 当前没有可交互悬停目标。 */
  None: 'none',
  /** 当前悬停中央标准视图元素。 */
  StandardView: 'standard-view',
  /** 当前悬停外部相机控制按钮。 */
  ControlAction: 'control-action',
} as const;

/** 视口方向导航器悬停目标类型。 */
export type ViewportGizmoHoverTargetKind =
  (typeof ViewportGizmoHoverTargetKind)[keyof typeof ViewportGizmoHoverTargetKind];

